export default {
  
  en: {
    timeStr: 'Actual Repayment Date',
    countSettleOrder: 'Actual Repayment Count',
    curReborrowCount: 'Same Day Re-borrow',
    reborrowCount2: 'Day 2 Re-borrow',
    reborrowCount3: 'Day 3 Re-borrow',
    reborrowCount4: 'Day 4 Re-borrow',
    reborrowCount5: 'Day 5 Re-borrow',
    reborrowCount6: 'Day 6 Re-borrow',
    reborrowCount7: 'Day 7 Re-borrow',
    reborrowCount8: 'Total Re-borrow Count',
    rate1: 'First Day Re-borrow Rate',
    rate7: '7-Day Re-borrow Rate',
    rate10: '10-Day Re-borrow Rate',
    rate15: '15-Day Re-borrow Rate',
    rate: 'Re-borrow Rate',
    countSettleOrder2: 'Settlement Count',
    settlementTime: 'Actual Repayment Date',
    productType: 'Product Type',
    duration: 'Duration',
    all: 'All',
    days7: '7 Days',
    days10: '10 Days',
    days14: '14 Days',
    loanCountPlaceholder: 'Loan Count (comma separated)',
    applicationDate: 'Application Date',
    orderType: 'Order Type',
    firstLoan: 'First Loan',
    repeatLoan: 'Repeat Loan',
    appInfoType: 'Product Type',
    mainProduct: 'Main Product',
    multiLoanProduct: 'Multi-Loan Product',
    feeRate: 'Fee Rate',
    lastSettleType: 'Last Settlement Type',
    earlySettle: 'Early Settlement',
    dueDateSettle: 'Due Date Settlement',
    overdueSettle: 'Overdue Settlement',
    settleType: 'Settlement Type',
    extensionSettle: 'Extension Settlement',
    nonExtensionSettle: 'Non-Extension Settlement',
    total: 'Total',
  },
  es: {
    timeStr: 'Ngày hoàn trả thực tế',
    countSettleOrder: 'Số khoản hoàn trả thực tế',
    curReborrowCount: 'Tái vay trong ngày hoàn trả',
    reborrowCount2: 'Tái vay sau ngày hoàn trả +2',
    reborrowCount3: 'Tái vay sau ngày hoàn trả +3',
    reborrowCount4: 'Tái vay sau ngày hoàn trả +4',
    reborrowCount5: 'Tái vay sau ngày hoàn trả +5',
    reborrowCount6: 'Tái vay sau ngày hoàn trả +6',
    reborrowCount7: 'Tái vay sau ngày hoàn trả +7',
    reborrowCount8: 'Tổng số khoản tái vay',
    rate1: 'Tỷ lệ tái vay trong ngày hoàn trả',
    rate7: 'Tỷ lệ tái vay sau 7 ngày',
    rate10: 'Tỷ lệ tái vay sau 10 ngày',
    rate15: 'Tỷ lệ tái vay sau 15 ngày',
    rate: 'Tỷ lệ tái vay',
    countSettleOrder2: 'Số lần thanh toán',
    settlementTime: 'Ngày trả thực tế',
    productType: 'Loại sản phẩm',
    duration: 'Thời hạn',
    all: 'Tất cả',
    days7: '7 ngày',
    days10: '10 ngày',
    days14: '14 ngày',
    loanCountPlaceholder: 'Số lần vay (cách nhau bằng dấu phẩy)',
    applicationDate: 'Ngày đăng ký',
    orderType: 'Loại đơn hàng',
    firstLoan: 'Vay lần đầu',
    repeatLoan: 'Vay lại',
    appInfoType: 'Loại sản phẩm',
    mainProduct: 'Sản phẩm chính',
    multiLoanProduct: 'Sản phẩm vay đa khoản',
    feeRate: 'Tỷ lệ phí',
    lastSettleType: 'Loại thanh toán kỳ cuối',
    earlySettle: 'Thanh toán sớm',
    dueDateSettle: 'Thanh toán đúng hạn',
    overdueSettle: 'Thanh toán quá hạn',
    settleType: 'Loại thanh toán',
    extensionSettle: 'Thanh toán gia hạn',
    nonExtensionSettle: 'Thanh toán không gia hạn',
    total: 'Tổng',
  }
}
